module.exports = __webpack_public_path__ + "img/kim-robertsen-l.03a868a6.webp";